import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
import useToastr from "helpers/toastr";
import { useTranslation } from 'react-i18next';

export { PrivateRoute };

function PrivateRoute({ children }) {
    const toastr = useToastr();
    const { i18n, t } = useTranslation();
     /**
     * Used for redirecting to the public route if user not loggedIn
     */
    const navigate = useNavigate();
    const location = useLocation();
    const { user: authUser } = useSelector(({ Login }) => Login);

    

    if (!authUser?.Token) {
        toastr.error(t('login_to_access'), "left")
        // not logged in so redirect to login page with the return url
        return <Navigate to="/signin" state={{ from: location }} />
    }

    // authorized so return child components
    return children;
}